import Input from 'components/Input';
import Checkbox from 'components/Checkbox';
import { SOURCE_LABEL_MAX } from 'utils/source-page';
import styles from 'styles/modules/newsAlert/SourcePage.module.scss';

import { news_alerts } from 'lang/en.json';

const copy = news_alerts.create_alert.screen_3;

const SourcePageFields = ({
    sourceUrl,
    sourceLabel,
    isSponsored,
    canSponsor,
    onChange,
}) => {
    const labelTooLong = (sourceLabel || '').length > SOURCE_LABEL_MAX;

    return (
        <div className={styles.fields}>
            <p className={styles.description}>{copy.source_description}</p>
            <Input
                name="sourceUrl"
                type="url"
                labelAbove
                label={copy.source_url}
                value={sourceUrl || ''}
                onChange={(e) => onChange('sourceUrl', e.target.value)}
            />
            <Input
                name="sourceLabel"
                labelAbove
                label={copy.source_label}
                value={sourceLabel || ''}
                onChange={(e) => onChange('sourceLabel', e.target.value)}
                error={
                    labelTooLong && {
                        message: `Max ${SOURCE_LABEL_MAX} characters`,
                    }
                }
            />
            {/* Still shown once ticked, so a cleared URL can't leave it on unseen. */}
            {canSponsor && (sourceUrl?.trim() || isSponsored) && (
                <div>
                    <Checkbox
                        name="isSponsored"
                        label={copy.source_sponsored}
                        initialValue={!!isSponsored}
                        onChange={() => onChange('isSponsored', !isSponsored)}
                    />
                    <p className={styles.hint}>{copy.source_sponsored_hint}</p>
                </div>
            )}
        </div>
    );
};

export default SourcePageFields;
